/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindPurchaseOrdersByOrganizationCertificatesQueryResponse,
  FindPurchaseOrdersByOrganizationCertificatesPathParams,
  FindPurchaseOrdersByOrganizationCertificatesQueryParams,
} from "../types/FindPurchaseOrdersByOrganizationCertificates.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findPurchaseOrdersByOrganizationCertificatesQueryKey = (
  organizationId: FindPurchaseOrdersByOrganizationCertificatesPathParams["organizationId"],
  params: FindPurchaseOrdersByOrganizationCertificatesQueryParams
) =>
  [
    {
      url: "/v1/purchase-order/find-certificates-associated-po/:organizationId",
      params: { organizationId: organizationId },
    },
    ...(params ? [params] : []),
  ] as const

export type FindPurchaseOrdersByOrganizationCertificatesQueryKey = ReturnType<
  typeof findPurchaseOrdersByOrganizationCertificatesQueryKey
>

/**
 * @summary Find certificates associated POs
 * {@link /v1/purchase-order/find-certificates-associated-po/:organizationId}
 */
export async function findPurchaseOrdersByOrganizationCertificates(
  organizationId: FindPurchaseOrdersByOrganizationCertificatesPathParams["organizationId"],
  params: FindPurchaseOrdersByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindPurchaseOrdersByOrganizationCertificatesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/purchase-order/find-certificates-associated-po/${organizationId}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findPurchaseOrdersByOrganizationCertificatesQueryOptions(
  organizationId: FindPurchaseOrdersByOrganizationCertificatesPathParams["organizationId"],
  params: FindPurchaseOrdersByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findPurchaseOrdersByOrganizationCertificatesQueryKey(
    organizationId,
    params
  )
  return queryOptions<
    ResponseConfig<FindPurchaseOrdersByOrganizationCertificatesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindPurchaseOrdersByOrganizationCertificatesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(organizationId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      return findPurchaseOrdersByOrganizationCertificates(
        organizationId,
        params,
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Find certificates associated POs
 * {@link /v1/purchase-order/find-certificates-associated-po/:organizationId}
 */
export function useFindPurchaseOrdersByOrganizationCertificates<
  TData =
    ResponseConfig<FindPurchaseOrdersByOrganizationCertificatesQueryResponse>,
  TQueryData =
    ResponseConfig<FindPurchaseOrdersByOrganizationCertificatesQueryResponse>,
  TQueryKey extends QueryKey =
    FindPurchaseOrdersByOrganizationCertificatesQueryKey,
>(
  organizationId: FindPurchaseOrdersByOrganizationCertificatesPathParams["organizationId"],
  params: FindPurchaseOrdersByOrganizationCertificatesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindPurchaseOrdersByOrganizationCertificatesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findPurchaseOrdersByOrganizationCertificatesQueryKey(organizationId, params)

  const query = useQuery(
    {
      ...findPurchaseOrdersByOrganizationCertificatesQueryOptions(
        organizationId,
        params,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
